import { Injectable } from '@angular/core';
import { AudioService } from '@nimbus-library/features/shared/services/media/audio.service';
import { EmptyAudioService } from './empty-audio.service';
import { IAudioService } from './i-audio.service';
import { PlaylistAudioService } from './playlist-audio.service';

@Injectable({ providedIn: 'root' })
export class AudioServiceFactory {
  public getAudioService(dataSource: string | string[] | null): IAudioService {
    if (!dataSource) {
      return EmptyAudioService.instance;
    }
    if (typeof dataSource === 'string') {
      return this.createAudioService(dataSource);
    }
    if (Array.isArray(dataSource)) {
      return new PlaylistAudioService(dataSource, (u) => this.createAudioService(u));
    }
    throw new Error(`The parameter url ${dataSource} type ${typeof dataSource} is not supported.`);
  }

  private createAudioService(dataSource: string): AudioService {
    return new AudioService(dataSource, this.createAudio);
  }

  private createAudio: () => HTMLAudioElement = () => new Audio();
}
